<template>
  <v-main v-resize="onResize" ref="content" class="pt-0">
    <v-container fluid>
      <!--v-row>
        <page-title />
      </v-row-->
      <v-row style="height: calc(100% - 34px)">
        <v-col cols="12">
          <v-row class="h-75">
            <v-col cols="3">
              <v-card class="card-wrap">
                <v-row class="h-50">
                  <v-col cols="6" class="liquid"><user :value="values.LOGON_USER" :descendants="descendants"/></v-col>
                  <v-col cols="6" class="liquid"><session :value="values.LOGON_USER" :descendants="descendants"/></v-col>
                </v-row>
                <v-row class="h-50">
                  <v-col cols="3"></v-col>
                  <v-col cols="6" class="liquid"><duplication :value="values.LOGON_DUP" :descendants="descendants"/></v-col>
                  <v-col cols="3"></v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="9">
              <v-card class="d-flex pa-1 bg mb-1" height="39" outlined>
                <div class="mr-auto d-flex">
                  <!--time-navigator v-model="datetime" :increment="1" :active-increment.sync="activeIncrement" :backward="[30, 300]" :forward="[30, 300]"></time-navigator-->
                  <time-navigator-neo v-model="datetime" :increment="1" :active-increment.sync="activeIncrement" :backward="timeStep" :forward="timeStep"></time-navigator-neo>
                  <descendant-selector :store-name="storeName" />
                </div>
                <!--BEGIN::Added.by.KWShin.2024.03.28.-->
                <div>
                  <time-navigator-settings :options="settingOptions" />
                </div>
                <!--FINISH::Added.by.KWShin.2024.03.28.-->
              </v-card>
              <v-row style="height: calc(100% - 41px)">
                <v-col cols="12"><logon-user-chart ref="userChart" :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
                <v-col cols="12"><logon-session-chart ref="sssnChart" :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
                <v-col cols="12"><logon-duplication-chart ref="dupChart" :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="h-25">
            <v-col cols="12">
              <v-tabs v-model="selected" height="35" slider-size="3" class="rounded-0">
                <template v-for="(grid, idx) in gridList">
                  <v-tab :key="idx" :href="grid.href">{{ grid.text }}</v-tab>
                  <v-tab-item :ref="grid.code" :key="idx" :value="grid.code" :eager="true" transition="false" reverse-transition="false">
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <field-selectable-grid
                        :sstmId="systemId"
                        :code="grid.code"
                        :event-code="grid.eventCode"
                        :selected="selectedFields[grid.code]"
                        :height="height"
                        :on-fetch="grid.onFetch"
                        :store-name="storeName"
                        :timestamp="timestamp[grid.eventCode]"
                      />
                  </v-tab-item>
                </template>
                <v-row class="tab-button">
                  <v-col>
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <field-selector
                        :code="selected"
                        :selected="selectedFields[selected]"
                        :store-name="storeName"
                      />
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <grid-opener
                        :sstmId="systemId"
                        :code="selected"
                        :text="selectedGrid.text"
                        :event-code="selectedGrid.eventCode"
                        :descendants="descendants"
                        :timestamp="timestamp[selectedGrid.eventCode]"
                      />
                  </v-col>
                </v-row>
              </v-tabs>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import bus from '@/utils/bus';
import value from '@/store/dynamic/value';
import settingsGrid from '@/components/motlet/settings/grid';
import FieldSelector from '@/components/motlet/settings/FieldSelector';
import DescendantSelector from '../../components/DescendantSelector';
import FieldSelectableGrid from '../../components/abap/FieldSelectableGridNeo';
import GridOpener from '../../components/GridOpener';
import tabItemDenseable from '../../components/tabItemDenseable';
import referable from '../../components/referable';
import LogonUserChart from './chart/LogonUser';
import LogonSessionChart from './chart/LogonSession';
import LogonDuplicationChart from './chart/LogonDuplication';
import User from './value/User';
import Session from './value/Session';
import Duplication from './value/Duplication';
// Added.by.KWShin.2022.12.15.
import { isEmpty } from 'lodash';
// BEGIN::Added.by.KWShin.2024.03.29.
import { api } from '@/api/common/instances';
import settingsChart from '@/components/motlet/settings/chart.js';
import TimeNavigatorSettings from '@/components/TimeNavigatorSettings.vue';
// FINISH::Added.by.KWShin.2024.03.29.

export default {
  components: {
    DescendantSelector,
    LogonSessionChart,
    LogonUserChart,
    LogonDuplicationChart,
    Session,
    User,
    Duplication,
    FieldSelectableGrid,
    FieldSelector,
    GridOpener,
    // BEGIN::Added.by.KWShin.2024.03.29.
    TimeNavigatorSettings,
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  mixins: [tabItemDenseable, referable],
  data() {
    return {
      grids: [
        { code: 'G_ABAP_LOGON_USER', eventCode: 'LOGON_USER', onFetch: this.onFetchGrid, text: 'dv.title.user' },
        { code: 'G_ABAP_LOGON_DUP', eventCode: 'LOGON_DUP', onFetch: this.onFetchGrid, text: 'dv.title.dup' },
        { code: 'G_ABAP_LOGON_GRP', eventCode: 'LOGON_USER', onFetch: this.onFetchGrid, text: 'dv.title.logon.group' },
      ],
      timestamp: {
        LOGON_USER: 0,
        LOGON_DUP: 0,
      },
      values: {
        LOGON_USER: [],
        LOGON_DUP: [],
      },
      // storeName: 'detailview/abap/user',
      storeName: 'dv/abap/user',
      datetime: new Date(),
      activeIncrement: true,
      height: 0,
      selectedGridCode: null,
      // BEGIN::Added.by.KWShin.2024.03.28.
      settingOptions: {
        id: 'dv/abap/user',
        // TimeNavigator Interval for Moving
        tnim: {
          use: true,
          np: 10,
          moreNp: 30,
          unit: 10,
          minNp: 10,
          maxNp: 360,
        },
        cycle: 0,
      },
      xPoints: {
        user: 120,
        sssn: 120,
        dup: 120,
      },
      chartField: {
        user: settingsChart['C_ABAP_LOGON_USER'].fields[0].code,
        sssn: settingsChart['C_ABAP_LOGON_USER'].fields[1].code,
      },
      // FINISH::Added.by.KWShin.2024.03.28.
    };
  },
  watch: {
    systemId: {
      immediate: true,
      handler() {
        // referable.js 내에 위치한다.
        // router query로 시각이 지정되었는 지를 체크한다.
        this.referer();
        this.setDescendants();
        if (this.activeIncrement) {
          this.$websocket.realtime.connect();
        }
      },
    },
    activeIncrement: {
      handler(value) {
        if (value) {
          this.datetime = new Date();
          this.$websocket.realtime.connect();
        } else {
          this.$websocket.realtime.close();
        }
      },
    },
  },
  computed: {
    ...mapGetters('common/system', ['getDescendantsById']),
    // Added.by.KWShin.2024.03.28.
    ...mapState('common/user', ['username']),
    /**
     * Gnb의 GroupSelector에서 시스템을 변경하면,
     * route의 params의 systemId가 바뀐다.
     */
    systemId() {
      return this.$route.params.systemId;
    },
    selected: {
      get() {
        return this.selectedGridCode ? this.selectedGridCode : this.grids[0].code;
      },
      set(code) {
        this.selectedGridCode = code;
      },
    },
    selectedFields() {
      return this.grids.reduce((acc, gc) => {
        acc[gc.code] = settingsGrid[gc.code].fields.filter(f => f.display).map(f => f.value);
        return acc;
      }, {});
    },
    gridList() {
      // text는 i18n 키 → $t() 호출로 번역. computed라 locale 변경 시 자동 재평가.
      return this.grids.map(gc => ({ href: `#${gc.code}`, ...gc, text: this.$t(gc.text) }));
    },
    descendants() {
      return this.$store.getters[`${this.storeName}/get`];
    },
    selectedGrid() {
      return this.grids.find(grid => grid.code == this.selected);
    },
    // BEGIN::Added.by.KWShin.2024.03.28.
    userMonCycle() {
      return this.$store.getters['common/monitor/getMonitor'](this.systemId, 'C_ABAP_LOGON_USER').cycle / 1000;
    },
    timeStep() {
      return [this.settingOptions.tnim.np * this.userMonCycle, this.settingOptions.tnim.moreNp * this.userMonCycle];
    },
    // FINISH::Added.by.KWShin.2024.03.28.
  },
  methods: {
    getActive(descendant) {
      const {
        query: { d: descendantId },
      } = this.$route;
      return descendantId ? descendantId == descendant.id : true;
    },
    setDescendants() {
      if (!this.$store.hasModule(this.storeName.split('/'))) {
        this.$store.registerModules(this.storeName.split('/'), value);
      }
      this.$store.dispatch(
        `${this.storeName}/set`,
        this.getDescendantsById(this.systemId).map(d => ({
          systemId: d.systemId,
          id: d.id,
          color: d.color,
          active: this.getActive(d),
          // Added.by.KWShin.2023.04.18.
          shortAlias: d.shortAlias,
        })),
      );
    },
    onResize() {
      // BEGIN::Modified.by.KWShin.2024.07.05.
      // page-title 부분을 제거해서 높이 조정.
      // const height = window.innerHeight - 160;
      // this.height = height - height * 0.75 - 32;
      const height = window.innerHeight - 123;
      this.height = height - height * 0.75 - 6;
      // FINISH::Modified.by.KWShin.2024.07.05.
    },
    onFetchGrid({ eventCode, data }) {
      this.values[eventCode] = data;
    },
    addEventListener() {
      bus.$on(`change:timestamp-${this.storeName}`, ({ eventCode, timestamp }) => (this.timestamp[eventCode] = timestamp));
      bus.$on(`change:selected-fields-${this.storeName}`, ({ code, fields }) => (this.selectedFields[code] = fields));
      bus.$on(`set:active-increment-${this.storeName}`, active => (this.activeIncrement = active));
      //BEGIN::Added.by.KWShin.2024.03.28.
      /*
        Commmented.by.KWShin.2024.03.05.
        DetailViewSettings.vue에서 TimeNavigator의 이전/이후 Interval 설정에 변동이 생기면
        서버에 CONF_USER_MTL에 변동 내역을 저장하고
        Bus에서 신호가 온다.
      */
      bus.$on(`update:${this.settingOptions.id}-np`, np => {
        this.settingOptions.tnim.np = np;
      });
      bus.$on(`update:${this.settingOptions.id}-moreNp`, moreNp => {
        this.settingOptions.tnim.moreNp = moreNp;
      });
      bus.$on('update:activeIncrement', active => {
        this.activeIncrement = active;
      });
      //FINISH::Added.by.KWShin.2024.03.28.
    },
    removeEventListener() {
      bus.$off(`change:timestamp-${this.storeName}`);
      bus.$off(`change:selected-fields-${this.storeName}`);
      bus.$off(`set:active-increment-${this.storeName}`);
      //BEGIN::Added.by.KWShin.2024.03.29.
      bus.$off(`update:${this.settingOptions.id}-np`);
      bus.$off(`update:${this.settingOptions.id}-moreNp`);
      bus.$off('update:activeIncrement');
      //FINISH::Added.by.KWShin.2024.03.29.
    },
    /**
     * Added.by.KWShin.2024.03.29.
     * DB에서 각종 설정값을 읽어온다.
     */
    async getMotletProperties() {
      const rspn = await api.get(`/prefer/users/${this.username}/motlet-properties-like`, { params: { motletId: `${this.settingOptions.id}` } });

      let motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/np');
      if (!isEmpty(motletProp)) this.settingOptions.tnim.np = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/moreNp');
      if (!isEmpty(motletProp)) this.settingOptions.tnim.moreNp = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/user/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.user = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sssn/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.sssn = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/dup/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.dup = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/user/chartField');
      if (!isEmpty(motletProp)) this.chartField.user = motletProp.motletProperties;

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sssn/chartField');
      if (!isEmpty(motletProp)) this.chartField.sssn = motletProp.motletProperties;

      this.notify2Children();
    },
    /**
     * Added.by.KWShin.2024.03.29.
     * DB에서 설정값을 읽어오는 것이 완료됐거나
     * systemId, activeIncrement에 변동이 왔을 때
     * 그 사실을 자식에게 알려준다.
     */
    notify2Children() {
      this.$refs.userChart.xPointsChanged(this.xPoints.user);
      this.$refs.sssnChart.xPointsChanged(this.xPoints.sssn);
      this.$refs.dupChart.xPointsChanged(this.xPoints.dup);

      this.$refs.userChart.chartFieldChanged(this.chartField.user);
      this.$refs.sssnChart.chartFieldChanged(this.chartField.sssn);
    },
  },
  async created() {
    await this.getMotletProperties();
    this.addEventListener();
    this.settingOptions.cycle = this.userMonCycle;

    // BEGIN::Added.by.KWShin.2022.12.15.
    // URL Param으로 'dt'가 넘어오면, 실시간을 끄고 해당 시각 기준으로 보여준다.
    if (!isEmpty(this.$route.query.t)) {
      this.activeIncrement = false;
      this.datetime = new Date(parseInt(this.$route.query.t));
    }
    // FINISH::Added.by.KWShin.2022.12.15.

    /*
     * Added.by.KWShin.2024.08.15.
     * LineChart에서 클릭이 발생. TimeNavigator 기준시각을 변경시켜준다.
     */
    bus.$on(`click:chart-${this.storeName}`, xAxisValue => {
      this.datetime = new Date(xAxisValue);
    });
  },
  destroy() {
    this.removeEventListener();
    this.$websocket.realtime.close();

    // Added.by.KWShin.2024.08.15.
    bus.$off(`click:chart-${this.storeName}`);
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: initial !important;
}

.tab-button {
  text-align: end;
}

.tab-button .col {
  margin: 3px 0 0 0;
}

.liquid {
  margin: 10px 0 0 0;
}
</style>
